import { OrderCategory } from "../../api/endpoints/Order";
import {
  BASKET_CLEAR_COMPLETED,
  BASKET_PRODUCT_ADD_COMPLETED,
  BASKET_PRODUCT_REMOVE_COMPLETED,
  IBasketClearCompletedAction,
  IBasketProductAddCompletedAction,
  IBasketProductRemoveCompletedAction
} from "../action-creators/basket";
import { omit } from "lodash";
import { TOrderProductData } from "../../api/endpoints/OrderProduct";

type TBasketState = {
  data: {
    [id: string]: TOrderProductData<OrderCategory.REALTIME>
  }
};

type TAllowedActions =
  IBasketProductAddCompletedAction |
  IBasketProductRemoveCompletedAction |
  IBasketClearCompletedAction

const generateBasketProductId = () => Math.random().toString(36).substring(2);

const initialState = (): TBasketState => ({
  data: {}
});

const basketReducer = (state: TBasketState = initialState(), action: TAllowedActions) => {
  switch (action.type) {
    case BASKET_PRODUCT_ADD_COMPLETED:
      return {
        ...state,
        data: {
          ...state.data,
          [generateBasketProductId()]: action.product
        }
      };

    case BASKET_PRODUCT_REMOVE_COMPLETED:
      return {
        ...state,
        data: omit(state.data, action.productId)
      };

    case BASKET_CLEAR_COMPLETED:
      return initialState();

    default:
      return state;
  }
}

export default basketReducer;
